import React, { FC } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ContextComponent } from './gateway/Authentication/AppContext'
import RootContainer from './gateway/layout/RootContainer'
import { Dialogs } from './gateway/Authentication/DialogContext'

export const App: FC<{}> = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Dialogs>
        <ContextComponent>
          <RootContainer />
        </ContextComponent>
      </Dialogs>
    </BrowserRouter>
  )
}
